/*
  Belléa — Favoritos (corazón de "me gusta")
  Cero dependencias. Estado en localStorage, sin cuenta de cliente.
  - Clave: 'bellea:favorites' → array de handles de producto.
  - Sincroniza el estado visual de todos los botones [data-bellea-fav] al cargar.
  - El relleno inicial sin parpadeo lo aplica un <style> inline en el <head>
    (ver theme.liquid); aquí lo reconciliamos con la clase .is-fav y lo retiramos
    en el mismo turno síncrono, sin flash.
  - Cargado con defer.
*/
(function () {
  'use strict';

  var KEY = 'bellea:favorites';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Estado ---------------------------------------------------------- */
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) { /* almacenamiento lleno o bloqueado: se ignora */ }
  }

  function has(arr, handle) { return arr.indexOf(handle) !== -1; }

  /* ---- Botones --------------------------------------------------------- */
  function paintButton(btn, active) {
    btn.classList.toggle('is-fav', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Guardar en favoritos');
  }

  function buttonsFor(handle) {
    return document.querySelectorAll('[data-bellea-fav][data-fav-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]');
  }

  /* ---- Contador del header --------------------------------------------- */
  function updateCount(arr) {
    var n = arr.length;
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ---- Sincroniza todo el DOM visible ---------------------------------- */
  function syncAll() {
    var favs = read();
    document.querySelectorAll('[data-bellea-fav]').forEach(function (btn) {
      paintButton(btn, has(favs, btn.dataset.favHandle));
    });
    updateCount(favs);
    // Retira el <style> de relleno inicial: la clase .is-fav ya sostiene el estado.
    var initial = document.getElementById('bellea-fav-initial');
    if (initial) initial.parentNode.removeChild(initial);
  }

  /* ---- Alternar -------------------------------------------------------- */
  function toggle(handle, sourceBtn) {
    var favs = read();
    var active;
    if (has(favs, handle)) {
      favs = favs.filter(function (h) { return h !== handle; });
      active = false;
    } else {
      favs.push(handle);
      active = true;
    }
    write(favs);

    buttonsFor(handle).forEach(function (btn) {
      paintButton(btn, active);
      if (!reduceMotion) {
        btn.classList.remove('is-bumping');
        void btn.offsetWidth; // reflow → reinicia la animación
        btn.classList.add('is-bumping');
      }
    });
    updateCount(favs);

    // En la página de favoritos: al quitar, retira la tarjeta.
    if (!active) {
      var page = document.querySelector('bellea-favorites-page');
      if (page && page.removeCard) page.removeCard(handle);
    }

    return active;
  }

  /* ---- Delegación de clics --------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bellea-fav]');
    if (!btn) return;
    // Si el botón está dentro de un enlace, no navegar.
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.favHandle, btn);
  });

  // Sincroniza entre pestañas.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncAll();
  });

  /* ---- Página de favoritos --------------------------------------------- */
  if ('customElements' in window && !customElements.get('bellea-favorites-page')) {
    customElements.define('bellea-favorites-page', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-fav-grid]');
        this.empty = this.querySelector('[data-fav-empty]');
        this.base = this.dataset.favFetchBase || '/products/';
        this.render();
      }

      render() {
        var handles = read();
        if (!handles.length) { this.showEmpty(); return; }

        this.empty.setAttribute('hidden', '');
        this.grid.removeAttribute('hidden');
        this.grid.innerHTML = '';

        var self = this;
        // Preserva el orden de guardado; ignora los que fallen (producto borrado).
        handles.forEach(function (handle) {
          fetch(self.base + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
            .then(function (html) {
              var trimmed = html.trim();
              if (!trimmed) return;
              var li = document.createElement('li');
              li.className = 'grid__item';
              li.setAttribute('data-fav-item', handle);
              li.innerHTML = trimmed;
              // Revela de inmediato (no hay IntersectionObserver para nodos inyectados).
              li.querySelectorAll('.bellea-reveal').forEach(function (el) {
                el.classList.add('bellea-reveal--in');
                el.style.transitionDelay = '0ms';
              });
              self.grid.appendChild(li);
              syncAll();
            })
            .catch(function () { /* handle inválido: se omite */ });
        });
      }

      removeCard(handle) {
        var item = this.grid && this.grid.querySelector('[data-fav-item="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]');
        if (item) item.parentNode.removeChild(item);
        if (this.grid && !this.grid.children.length) this.showEmpty();
      }

      showEmpty() {
        if (this.grid) { this.grid.setAttribute('hidden', ''); this.grid.innerHTML = ''; }
        if (this.empty) this.empty.removeAttribute('hidden');
      }
    });
  }

  /* ---- Init ------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();
